import { Injectable } from "@angular/core";
import { doc, docData, Firestore } from '@angular/fire/firestore';
import { Store } from "@ngxs/store";
import { combineLatest, Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AnnualDeclarationState } from "~app/company/form/annual-declaration-form/shared/state/annual-declaration.state";
import { LegalEntity } from "~app/company/shared/model/legal-entity";

@Injectable({
  providedIn: 'root',
})
export class LegalEntityFirebaseService {
  year$ = this.store.select<number>(AnnualDeclarationState.year);

  constructor(
    private store: Store,
    private firestore: Firestore) {
  }

  /**
   * A newly created legal entity does not have to fill out the declaration form the first year of its creation
   * @param legalEntityId 
   * @returns 
   */
isRecentlyCreatedLegalEntity(legalEntityId: string): Observable<boolean> {
  return combineLatest([
    this.getLegalEntity(legalEntityId),
    this.year$
  ]).pipe(
    map(([legalEntity, year]) => {
      const practiceStartDate = new Date(legalEntity.practiceStartDate);
      return practiceStartDate.getFullYear() >= year;
    })
  );
}

 getLegalEntity(legalEntityId: string): Observable<LegalEntity> {
  const legalEntityRef = doc(
    this.firestore,
    `legal-entities/${legalEntityId}`
  );

  return docData(legalEntityRef).pipe(
    take(1),
    map(data => data as LegalEntity)
  );
}
}